import Button from "components/components/Button/Button";
import styled from "styled-components";
import colours from "styles/colours";
import fonts from "styles/fonts";

export const QueueInfoContainer = styled.div`
  margin-bottom: 2.5em;
  background: ${colours.white};
  margin-left: 1em;
  border-left: 1px solid ${colours.elexonBlue};
  box-shadow: 0 4px 6px -2px rgba(0, 0, 0, 0.03),
    0 12px 16px -4px rgba(0, 0, 0, 0.08);
`;

export const QueueInfoHeader = styled.div`
  color: ${colours.elexonBlack};
  padding: 1.25em 2.75em;
  background: ${colours.backgroundGrey};
  position: relative;
`;

export const QueueInfoHeaderInner = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
`;

export const QueueInfoHeaderTitle = styled.span`
  font-size: 1.6em;
  font-weight: 900;
  word-break: break-all;
`;

export const QueueInfoContent = styled.div`
  background: ${colours.white};
  padding: 0.75em 1.5em;
`;

export const QueueDetailsRow = styled.div`
  display: grid;
  grid-template-columns: 220px minmax(0, 1fr) max-content;
  column-gap: 1.5em;
  align-items: center;
  position: relative;
  padding: 0.2em 1.25em;

  &:first-child::before {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    height: 1px;
    background: ${colours.elexonBlue};
  }

  &::after {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: 1px;
    background: ${colours.elexonBlue};
  }

  > :last-child {
    justify-self: end;
    align-self: center;
    display: flex;
    align-items: center;
  }

  @media (max-width: 48em) {
    grid-template-columns: 1fr;
    row-gap: 0.5em;

    > :last-child {
      justify-self: start;
    }
  }
`;

export const Label = styled.span`
  font-weight: 700;
  color: ${colours.elexonBlack};
`;

export const Value = styled.span`
  color: ${colours.darkGrey};
  word-break: break-word;
`;

export const DeleteQueueButton = styled(Button)`
  & {
    background-color: transparent;
    color: ${colours.elexonBlack};
    border: none;
    border-radius: 0;
    font-size: ${fonts.small};
    text-transform: none;
    letter-spacing: 0;
    padding: 0;
    text-underline-offset: 4px;
    box-shadow: none;
    text-decoration: underline;

    &:active {
      box-shadow: none;
    }

    &:hover {
      color: ${colours.elexonBlue};
      text-decoration: underline;
      background: none;
    }

    &:focus {
      color: ${colours.elexonBlack};
    }

    &:focus-visible {
      outline: 2px solid ${colours.elexonBlack};
      outline-offset: 4px;
    }

    &:disabled {
      background-color: transparent;
    }
  }
`;
